import api from '@/api';

const resource = 'ei/coordenadorreports';

export default {
  getNotificacoes( data ) {
    return api.get(`${resource}/notificacoes`, { params: data });
  },
};
